module.exports = __webpack_public_path__ + "static/media/28.1f0f87f3.gif";